import { Component, Input, ChangeDetectorRef } from "@angular/core";
import { GraphicsInfoColorField } from "../../../../domain/graphics-info";

@Component({
  selector: "icn-color-component",
  templateUrl: "./color.component.html",
  styleUrls: ["./color.component.scss"],
})
export class GraphicsColorComponent {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  @Input()
  colorField: GraphicsInfoColorField;

  getColorValue(): string {
    return this.colorField?.value?.[0] ?? '';
  }

  setColorValue(v: string): void {
    if (this.colorField?.value?.length) {
      this.colorField.value[0] = v;
    }
  }
}
